exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2CJpC{background-color:#fff;padding:12px 0;padding:.75rem 0;border-bottom:0}._2CJpC span{color:red}._2CJpC img{cursor:pointer}._2CJpC i{color:#e4002b;font-size:30px;margin:0 15px}._2CJpC h4{cursor:pointer;text-align:center}._2CJpC h4 img{margin-left:15px}._1N94f{background-color:#fafafa}", ""]);

// exports
exports.locals = {
	"header_card": "_2CJpC",
	"backColor": "_1N94f"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/CardHeader/CardHeader.css
// module id = 1258
// module chunks = 0 1